var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloseCircle = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#closeCircle_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#242E30",
  d: "M16.305 9.086 13.391 12l2.914 2.914-1.391 1.391L12 13.391l-2.914 2.914-1.391-1.391L10.609 12 7.695 9.086l1.391-1.391L12 10.609l2.914-2.914zM22.172 12A10.172 10.172 0 1 1 12 1.828 10.185 10.185 0 0 1 22.172 12m-1.969 0a8.204 8.204 0 1 0-16.407 0 8.204 8.204 0 0 0 16.407 0"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "closeCircle_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M1.5 1.5h21v21h-21z"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloseCircle);
export default ForwardRef;